var _defs, _path, _path2, _path3, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.54 212.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-compass{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-compass",
    d: "M303.93,626.58a92.27,92.27,0,1,0,105.57-91.3,17.74,17.74,0,1,0-26.6,0,92.4,92.4,0,0,0-79,91.3h0Zm81.62-102.91a10.65,10.65,0,1,1,10.65,10.65,10.65,10.65,0,0,1-10.65-10.65h0Zm10.65,17.74A85.17,85.17,0,1,1,311,626.58a85.17,85.17,0,0,1,85.17-85.17h0Zm0,0",
    transform: "translate(-303.93 -505.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-compass",
    d: "M396.2,701.1a74.52,74.52,0,1,0-74.52-74.53A74.53,74.53,0,0,0,396.2,701.1h0Zm0-142a67.43,67.43,0,1,1-67.43,67.43,67.43,67.43,0,0,1,67.43-67.43h0Zm0,0",
    transform: "translate(-303.93 -505.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-compass",
    d: "M373.36,630.13l-19.27,33.71a3.55,3.55,0,0,0,4.85,4.85l33.71-19.27v33.94a3.55,3.55,0,0,0,3.55,3.55h0a3.55,3.55,0,0,0,3.55-3.55v-38l6.5-3.72,27.59,27.59a3.55,3.55,0,0,0,5,0h0a3.55,3.55,0,0,0,0-5l-27.59-27.58,3.72-6.51h34.44a3.55,3.55,0,0,0,3.55-3.55h0a3.55,3.55,0,0,0-3.55-3.55H419l19.27-33.71a3.55,3.55,0,0,0-4.85-4.85l-33.71,19.27V569.8a3.55,3.55,0,0,0-3.55-3.55h0a3.55,3.55,0,0,0-3.55,3.55v38l-6.5,3.72-27.59-27.59a3.55,3.55,0,0,0-5,0h0a3.55,3.55,0,0,0,0,5l27.59,27.59L377.42,623H343a3.55,3.55,0,0,0-3.55,3.55h0a3.55,3.55,0,0,0,3.55,3.55h30.39Zm52.34-33-21.45,37.54L366.7,656.08l21.45-37.54Zm0,0",
    transform: "translate(-303.93 -505.92)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-compass",
    x: 87.92,
    y: 116.31,
    width: 8.69,
    height: 8.69,
    rx: 4.34,
    ry: 4.34
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompass);
export default __webpack_public_path__ + "static/media/Logo_compass.25a592d2.svg";
export { ForwardRef as ReactComponent };